<div
    class="container-fluid gx-0 pt-3 mb-26 mb-sm-20 container-start-reservation"
>
    <h4 class="container-start-reservation-title mb-3 fw-bold text-fifth">
        {{ 'fe-core-start-reservation-h4-title' | translate }}
    </h4>
    <fe-button
        [fragment]="'doReservation'"
        [href]="'' | formatUrl"
        [style]="'tertiary'"
        >{{ 'fe-core-start-reservation-button-start' | translate }}</fe-button
    >
</div>
